import type { PokemonItem } from '../types/item';

// ポケモンの道具一覧と利用関数を提供
export const POKEMON_ITEMS: PokemonItem[] = [
  {
    id: 775670783,
    name: "なし",
    showInOffence: true,
    showInDefence: true,
  },
  // 攻撃側アイテム
  {
    id: 197,
    name: "こだわりハチマキ",
    showInOffence: true,
    showInDefence: false,
  },
  {
    id: 274,
    name: "こだわりメガネ",
    showInOffence: true,
    showInDefence: false,
  },
  {
    id: 264,
    name: "こだわりスカーフ",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 247,
    name: "いのちのたま",
    showInOffence: true,
    showInDefence: false,
  },
  {
    id: 235,
    name: "ふといホネ",
    showInOffence: true,
    showInDefence: false,
  },
  {
    id: 213,
    name: "でんきだま",
    showInOffence: true,
    showInDefence: false,
  },
  {
    id: 243,
    name: "ちからのハチマキ",
    showInOffence: true,
    showInDefence: false,
  },
  {
    id: 244,
    name: "ものしりメガネ",
    showInOffence: true,
    showInDefence: false,
  },
  {
    id: 1700,
    name: "パンチグローブ",
    showInOffence: true,
    showInDefence: false,
  },
  {
    id: 669,
    name: "ノーマルジュエル",
    showInOffence: true,
    showInDefence: false,
  },
  {
    id: 1161,
    name: "くちたけん",
    showInOffence: true,
    showInDefence: false,
  },
  {
    id: 1162,
    name: "くちたたて",
    showInOffence: true,
    showInDefence: false,
  },
  {
    id: 275,
    name: "ひのたまプレート",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 276,
    name: "しずくプレート",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 277,
    name: "いかずちプレート",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 278,
    name: "みどりのプレート",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 279,
    name: "つららのプレート",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 280,
    name: "こぶしのプレート",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 281,
    name: "もうどくプレート",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 282,
    name: "だいちのプレート",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 283,
    name: "あおぞらプレート",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 284,
    name: "ふしぎのプレート",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 285,
    name: "たまむしプレート",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 286,
    name: "がんせきプレート",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 287,
    name: "もののけプレート",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 288,
    name: "りゅうのプレート",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 289,
    name: "こわもてプレート",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 290,
    name: "こうてつプレート",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 684,
    name: "せいれいプレート",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 563,
    name: "アクアカセット",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 564,
    name: "イナズマカセット",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 565,
    name: "ブレイズカセット",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 566,
    name: "フリーズカセット",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 910,
    name: "ファイヤーメモリ",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 911,
    name: "ウオーターメモリ",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 913,
    name: "エレクトロメモリ",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 912,
    name: "グラスメモリ",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 915,
    name: "アイスメモリ",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 902,
    name: "ファイトメモリ",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 904,
    name: "ポイズンメモリ",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 905,
    name: "グラウンドメモリ",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 903,
    name: "フライングメモリ",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 914,
    name: "サイキックメモリ",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 907,
    name: "バグメモリ",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 906,
    name: "ロックメモリ",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 908,
    name: "ゴーストメモリ",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 916,
    name: "ドラゴンメモリ",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 917,
    name: "ダークメモリ",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 909,
    name: "スチールメモリ",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 918,
    name: "フェアリーメモリ",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 113,
    name: "しらたま",
    showInOffence: true,
    showInDefence: false,
  },
  {
    id: 112,
    name: "こんごうだま",
    showInOffence: true,
    showInDefence: false,
  },
  {
    id: 442,
    name: "はっきんだま",
    showInOffence: true,
    showInDefence: false,
  },
  {
    id: 202,
    name: "こころのしずく",
    showInOffence: true,
    showInDefence: false,
  },
  {
    id: 245,
    name: "たつじんのおび",
    showInOffence: true,
    showInDefence: false,
  },
  // Zクリスタル（タイプ別）
  {
    id: 817,
    name: "ノーマルZ",
    showInOffence: true,
    showInDefence: false,
  },
  {
    id: 821,
    name: "クサZ",
    showInOffence: true,
    showInDefence: false,
  },
  {
    id: 818,
    name: "ホノオZ",
    showInOffence: true,
    showInDefence: false,
  },
  {
    id: 819,
    name: "ミズZ",
    showInOffence: true,
    showInDefence: false,
  },
  {
    id: 941,
    name: "デンキZ",
    showInOffence: true,
    showInDefence: false,
  },
  {
    id: 826,
    name: "ヒコウZ",
    showInOffence: true,
    showInDefence: false,
  },
  {
    id: 823,
    name: "カクトウZ",
    showInOffence: true,
    showInDefence: false,
  },
  {
    id: 825,
    name: "ジメンZ",
    showInOffence: true,
    showInDefence: false,
  },
  {
    id: 828,
    name: "ムシZ",
    showInOffence: true,
    showInDefence: false,
  },
  {
    id: 829,
    name: "イワZ",
    showInOffence: true,
    showInDefence: false,
  },
  {
    id: 832,
    name: "アクZ",
    showInOffence: true,
    showInDefence: false,
  },
  {
    id: 822,
    name: "コオリZ",
    showInOffence: true,
    showInDefence: false,
  },
  {
    id: 824,
    name: "ドクZ",
    showInOffence: true,
    showInDefence: false,
  },
  {
    id: 833,
    name: "ハガネZ",
    showInOffence: true,
    showInDefence: false,
  },
  {
    id: 830,
    name: "ゴーストZ",
    showInOffence: true,
    showInDefence: false,
  },
  {
    id: 827,
    name: "エスパーZ",
    showInOffence: true,
    showInDefence: false,
  },
  {
    id: 831,
    name: "ドラゴンZ",
    showInOffence: true,
    showInDefence: false,
  },
  {
    id: 834,
    name: "フェアリーZ",
    showInOffence: true,
    showInDefence: false,
  },
  // 防御側アイテム
  {
    id: 683,
    name: "とつげきチョッキ",
    showInOffence: false,
    showInDefence: true,
  },
  {
    id: 581,
    name: "しんかのきせき",
    showInOffence: false,
    showInDefence: true,
  },
  {
    id: 3,
    name: "半減きのみ",
    showInOffence: false,
    showInDefence: true,
  },
  // 共通アイテム
  {
    id: 584,
    name: "ふうせん",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 467,
    name: "べにいろのたま",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 468,
    name: "あいいろのたま",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 1659,
    name: "だいこんごうだま",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 1660,
    name: "だいしらたま",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 1661,
    name: "だいはっきんだま",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 2106,
    name: "いどのめん",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 2107,
    name: "かまどのめん",
    showInOffence: true,
    showInDefence: true,
  },
  {
    id: 2108,
    name: "いしずえのめん",
    showInOffence: true,
    showInDefence: true,
  },
];

// 攻撃側で選択可能なアイテム一覧
export const getOffenceItems = (): PokemonItem[] => {
  return POKEMON_ITEMS.filter((item) => item.showInOffence);
};

// 防御側で選択可能なアイテム一覧
export const getDefenceItems = (): PokemonItem[] => {
  return POKEMON_ITEMS.filter((item) => item.showInDefence);
};
